import { render } from "./IconDateRange.vue?vue&type=template&id=dde9fb70"
import script from "./IconDateRange.vue?vue&type=script&lang=js"
export * from "./IconDateRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__